import {
  BOOKS_CHANNEL_CUSTOM_TYPE,
  COMPANY_GROUP_CUSTOM_TYPE,
} from "constants/channelType";
import { NO_ASSGINEE_KEY } from "constants/agent";
import { useChatFilterContext } from "contexts/ChatFilterContext";
import { ChannelFilters } from "stream-chat";
import { DefaultStreamChatGenerics } from "stream-chat-react";

export const useStreamFilterQuery =
  (): ChannelFilters<DefaultStreamChatGenerics> => {
    const { filters: values } = useChatFilterContext();

    const customTypeFilterValues = [];

    if (values.CHANNEL.some((channel) => channel === "GENERAL_HELP")) {
      customTypeFilterValues.push(COMPANY_GROUP_CUSTOM_TYPE);
    }
    if (values.CHANNEL.some((channel) => channel === "BOOKS")) {
      customTypeFilterValues.push(BOOKS_CHANNEL_CUSTOM_TYPE);
    }

    let typeFilter = {};

    if (values.CHANNEL.length > 0 && customTypeFilterValues.length > 0) {
      // Both filters have values, use $or
      typeFilter = {
        $or: [
          {
            channel_type: {
              $in: values.CHANNEL,
            },
          },
          {
            custom_type: {
              $in: customTypeFilterValues,
            },
          },
        ],
      };
    } else if (values.CHANNEL.length > 0) {
      // Only channel type has values
      typeFilter = {
        channel_type: {
          $in: values.CHANNEL,
        },
      };
    }

    return {
      ...typeFilter,

      ...(values.COMPANY.length > 0 && {
        group_uuid: {
          $in: values.COMPANY,
        },
      }),

      ...(values.AGENT.length > 0 &&
        (() => {
          const hasUnassigned = values.AGENT.includes(NO_ASSGINEE_KEY);
          const assignedAgents = values.AGENT.filter(
            (agent) => agent !== NO_ASSGINEE_KEY
          );

          if (hasUnassigned && assignedAgents.length > 0) {
            return {
              $or: [
                { assigned_agent: { $in: assignedAgents } },
                { assigned_agent: { $exists: false } },
              ],
            };
          }

          if (hasUnassigned) {
            return { assigned_agent: { $exists: false } };
          }

          return { assigned_agent: { $in: assignedAgents } };
        })()),

      ...(values.STATUS.length > 0 && {
        task_status_id: {
          $in: values.STATUS,
        },
      }),

      ...(values.START_DATE &&
        values.END_DATE && {
          $and: [
            {
              last_message_at: {
                $gte: new Date(values.START_DATE).toISOString(),
              },
            },

            {
              last_message_at: {
                $lte: new Date(values.END_DATE).toISOString(),
              },
            },
          ],
        }),
    };
  };
